module.exports = __webpack_public_path__ + "img/progressSimulation_checked.5b418655.png";